import Banner from './banner'
import { commonRenderProps } from '../../common/props'
import renderDialog from '../../dialog/render'
import { openChargebeeCheckout } from '../../common/useChargebee'

const CARRIER_BANNER_STORAGE_KEY = 'mbo_carrier_banner_loaded_'
type CarrierBannerState = 'active' | 'dismissed' | 'completed'

const needToLoadBanner = (context: any) => {
  const controllerName =
    context['prestaShop_controller_class_name'] ||
    context['prestaShopControllerClassName'] ||
    ''
  if (controllerName !== 'AdminCarriers') {
    return false
  }
  const shopuid = context.accounts_shop_id || ''
  const bannerState = localStorage.getItem(CARRIER_BANNER_STORAGE_KEY + shopuid)
  return !bannerState || bannerState === 'active'
}

const removeShippingPromote = () => {
  const styleEl = document.createElement('style')
  styleEl.textContent = `
      #shipping-promote { display: none !important; }
    `
  document.head.appendChild(styleEl)
}

const prepareBannerContainer = (elId: string): HTMLElement | null => {
  const mainDiv =
    document.querySelector('#main-div .content-div') ||
    document.querySelector('#main #content')
  if (!mainDiv) return null
  const el = document.createElement('div')
  el.id = elId
  mainDiv.insertBefore(el, mainDiv.firstChild)
  return el
}

const removeCoreCarrierBanner = () =>
  document.querySelector('#carriersShowcaseCard')?.remove()

export default (context: object, onDialogClose?: () => void) => {
  if (!needToLoadBanner(context)) {
    return
  }

  removeShippingPromote()
  removeCoreCarrierBanner()

  if (prepareBannerContainer('carrierBanner')) {
    Banner({
      ...commonRenderProps({ context }),

      setBannerSeen: (state: CarrierBannerState = 'completed') => {
        const shopuid = context['accounts_shop_id'] || ''
        localStorage.setItem(CARRIER_BANNER_STORAGE_KEY + shopuid, state)
      },

      handleOpenDialog: (dialogName: string, dialogContext: object) => {
        renderDialog(
          context,
          dialogName,
          {
            ...dialogContext,
            onClose: () => {
              ;(dialogContext as any).onClose?.()
              onDialogClose?.()
            },
          },
          {
            handleOpenChargebeeCheckout: (opts) => openChargebeeCheckout(opts),
          },
        )
      },
    }).render('#carrierBanner')
  }
}
